module.exports = __webpack_public_path__ + "static/media/Room15.6cd41eb0.PNG";